"use client"

import React, { useLayoutEffect, useRef, useState } from "react";
import EditorJS from "@editorjs/editorjs";
import PropTypes from "prop-types";
import Header from "@editorjs/header";
import List from  "@editorjs/list";
import AlignmentBlockTune from "editorjs-text-alignment-blocktune";
import ColorPicker from 'editorjs-color-picker';
import Underline from '@editorjs/underline';

const Editor = ({ id,  data }) => {
  const language = typeof window !== "undefined" ? window.location.pathname.split("/")[1] : "";

  const [isClient, setIsClient] = useState(false);
  const ejInstance = useRef();

  // Use useLayoutEffect instead of useEffect to ensure DOM elements are ready
  useLayoutEffect(() => {
    setIsClient(true);
  }, []);

  const initEditor = () => {
    const editor = new EditorJS({
      holder: id,
      onReady: () => {
        ejInstance.current = editor;
      },
      readOnly: true,
      tools: {
        list: List,
        header: {
          class: Header,
          tunes: ['alignment'],
        },
        ColorPicker: {
          class: ColorPicker,
        },
        underline: Underline,
        alignment: {
          class: AlignmentBlockTune,
          config: {
            default: language === "ar" ? "right" : "left",
            blocks: {
              header: 'center',
              list: 'right',
              paragraph: language === "ar" ? "right" : "left",
            }
          },
        },
      },
      i18n: {
        direction: language === "ar" ? "rtl" : "ltr",
      },
      data: JSON?.parse(data),
      tunes: ['alignment'],
    });
  };

  useLayoutEffect(() => {
    if (isClient && !ejInstance.current) {
      initEditor();
    }

    return () => {
      ejInstance?.current?.destroy();
      ejInstance.current = null;
    };
  }, [isClient, language]);

  if (!isClient) return null;  // Render nothing on the server side

  return (
    <>
      <div className="prose" id={id} dir={language === "ar" ? "rtl" : "ltr"} style={{
        paddingBlock: "0.2rem",
        fontSize: "0.984rem"
      }}></div>
      <style>
        {`
          #${id} .cdx-input.image-tool__caption {
            visibility: hidden;
            margin-top: -46px;
          }
         .ce-block__content {
         max-width: 100%;
        }
        `}
      </style>
    </>
  );
}

Editor.propTypes = {
  language: PropTypes.string,
};

export default Editor;
